import React from "react";
import { Route, Redirect } from "react-router-dom";
import usePermission from "hooks/usePermission";

const PermissionRoute = ({ permission, redirectTo, children, component: Component, ...rest }) => {
  const { can } = usePermission();

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!can(permission)) {
          return <Redirect to={redirectTo} />;
        }
        if (Component) return <Component {...routeProps} />;
        return children;
      }}
    />
  );
};

export default PermissionRoute;
